import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import Flash from '../components/forms/Flash';

const Dialog = (props) => {
  const {
    isOpen,
    errors,
    message,
    onConfirm,
    onCancel,
    children,
    onConfirmDisabled,
  } = props;
  const messageSplit = message.split('\n');

  if (!isOpen) {
    return null;
  }

  return (
    <div className="dialog-container">
      <div className="dialog">
        {!isEmpty(errors) && <Flash response={errors} />}
        <div className="end-offer dialog-title">
          <p key="0">{messageSplit[0]}</p>
        </div>
        {children && (
          <div className="end-offer dialog-children">{children}</div>
        )}
        <div className="end-offer dialog-title">
          {messageSplit.map((line, i) => {
            if (i > 0)
              return (
                <p key={i} className="dialog-black-text">
                  {line}
                </p>
              );
          })}
        </div>

        <div className="end-offer dialog-actions">
          <button
            className="dialog-confirm delete"
            onClick={onConfirm}
            disabled={onConfirmDisabled}
          >
            Confirm
          </button>
          <button className="dialog-cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

Dialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  onConfirmDisabled: PropTypes.bool,
};

Dialog.defaultProps = {
  errors: {},
  onConfirmDisabled: false,
};

export default Dialog;
